module.exports = __webpack_public_path__ + "img/connect_step2.81d60a63.png";